import React, { useState, useEffect } from 'react';
import { getBalanceSheet } from '../../../api/BalanceSheetAPI';
import AppBreadCrumb from '../../common/AppBreadCrumb';

const BalanceSheetPage = () => {
    const [members, setMembers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showNegativeOnly, setShowNegativeOnly] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const filters = showNegativeOnly ? { filter: 'negative_balance' } : {};
        
        getBalanceSheet(filters, (data) => {
            setIsLoading(false);
            if (Array.isArray(data)) {
                setMembers(data);
            }
        });
    }, [showNegativeOnly]);

    const getRowClass = (balance) => {
        if (balance < 0) return 'table-danger';
        if (balance >= 0 && balance < 200) return 'table-warning';
        return 'table-success';
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <main>
                <div className="container-fluid">
                    <div id="page-header">
                        <AppBreadCrumb title="Club Balance Sheet" />
                    </div>
                    
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center" id="page-controls">
                            <div className="form-check form-switch">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="negativeBalanceFilter"
                                    checked={showNegativeOnly}
                                    onChange={(e) => setShowNegativeOnly(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="negativeBalanceFilter">
                                    Show Negative Balances Only
                                </label>
                            </div>
                            <button className="btn btn-primary" onClick={handlePrint}>
                                <i className="fas fa-print me-2"></i>Print List
                            </button>
                        </div>
                        <div className="card-body">
                            {isLoading ? (
                                <div className="text-center p-5"><div className="spinner-border"></div></div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Member Name</th>
                                                <th scope="col" className="text-end">Current Balance (₹)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {members.map((member, index) => (
                                                <tr key={member.id} className={getRowClass(member.current_wallet_balance)}>
                                                    <td>{index + 1}</td>
                                                    <td>{member.name}</td>
                                                    <td className="text-end fw-bold">{Number(member.current_wallet_balance).toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>

            {/* Print-specific styles */}
            <style type="text/css" media="print">
                {`
                    body {
                        background-color: #fff !important;
                    }
                    #app-sidebar, #app-header, #page-header, #page-controls {
                        display: none !important;
                    }
                    main {
                        padding-top: 0 !important;
                    }
                    .card {
                        border: none !important;
                        box-shadow: none !important;
                    }
                    .table {
                        font-size: 12px;
                    }
                    .table-danger {
                        --bs-table-bg: #f8d7da !important;
                         color: #000 !important;
                    }
                    .table-warning {
                        --bs-table-bg: #fff3cd !important;
                        color: #000 !important;
                    }
                     .table-success {
                        --bs-table-bg: #d1e7dd !important;
                        color: #000 !important;
                    }
                    @page {
                        size: A4;
                        margin: 1cm;
                    }
                `}
            </style>
        </>
    );
};

export default BalanceSheetPage;